import Dispatcher from "../Dispatcher";
import {Store} from "flux/utils";

const addressBooks: { [bookKey: string]: boolean } = {};

class Action
{
	constructor(dialogKey: string, state: boolean)
	{
		this.type = dialogKey;
		this.state = state;
	}

	type: string;
	state: boolean;
}

class AddressBookDialogStore extends Store<Action>
{
	openDialog(dialogKey: string, state: boolean)
	{
		this.getDispatcher().dispatch(new Action(dialogKey, state));
	}

	isDialogOpen(dialogKey: string) { return addressBooks[dialogKey]; }

	// ReSharper disable once InconsistentNaming required because of base class
	__onDispatch(payload: Action): void
	{
		addressBooks[payload.type] = payload.state;
		this.__emitChange();
	}
}

export default new AddressBookDialogStore(Dispatcher);


// WEBPACK FOOTER //
// ./src/stores/AddressBookDialogStore.ts